import * as React from 'react';
import { IconDomRf } from './domRf';
import { IconCianJournal } from './cianJournal';

type TIcons = { [key: string]: React.ReactElement };
export const ICONS: TIcons = {
  domRf: <IconDomRf />,
  cianJournal: <IconCianJournal />,
};
